import { createReducer, on, Action } from '@ngrx/store';

import * as CopyAdviceActions from './copy-advice.actions';
import { CopyAdviceState } from '../copy-advice.models';

const copyAdviceReducer = createReducer<CopyAdviceState>(
  {},
  on(CopyAdviceActions.copyTreatmentsStarted, (state, { amountOfAdvices }) => ({
    ...state,
    amountOfAdvicesCopying: (state.amountOfAdvicesCopying ?? 0) + amountOfAdvices,
    copyDialogDismissed: false,
    copyStatusDismissed: false,
  })),
  on(CopyAdviceActions.completedCopyTreatments, (state) => ({
    ...state,
    amountOfAdvicesCompleted: (state.amountOfAdvicesCompleted ?? 0) + 1,
  })),
  on(CopyAdviceActions.completedCopyAll, (state) => ({
    ...state,
    amountOfAdvicesCopying: 0,
    amountOfAdvicesCompleted: 0,
  })),
  on(CopyAdviceActions.copyDialogDismissed, (state) => ({
    ...state,
    copyDialogDismissed: true,
  })),
  on(CopyAdviceActions.dismissCopyAdviceStatus, (state) => ({
    ...state,
    copyStatusDismissed: true,
  })),
);

export const reducer = (state: CopyAdviceState | undefined, action: Action) =>
  copyAdviceReducer(state, action);
